module.exports = __webpack_public_path__ + "static/img/banner-c.2349f56d.png";